<template>
  <div>
      <img :src="logo" alt="" class="logo">
  </div>
</template>

<script>
export default {
    props:['logo']

}
</script>

<style lang='scss' scoped>
.logo {
    width: 100%;
    margin-top: 5px;
    background: #1989fa;
    border-radius: 5px;
    margin-bottom: 20px;
    box-sizing: border-box;
    padding: 0 10px;
    img {
        width: 100%;
    }
}

</style>